"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const simplerestclients_1 = require("simplerestclients");
const BaseRestClient_1 = require("./BaseRestClient");
function transform(model) {
    return {
        action: 'Chat',
        flowId: model.flowId,
        id: model.longId,
        resource: model.threadId,
    };
}
const transformWrapper = (shortId) => (model) => ({
    ...transform(model),
    shortId,
});
const shouldRetry = (statusCode) => statusCode === 0 || (statusCode >= 500 && statusCode < 600);
// @todo: add logging if needed
const customErrorHandler = ({}, errResp) => shouldRetry(errResp.statusCode) ? simplerestclients_1.ErrorHandlingType.RetryCountedWithBackoff : simplerestclients_1.ErrorHandlingType.DoNotRetry;
class MeetingsApiClient extends BaseRestClient_1.BaseRestClient {
    joinAsGuest(payload, retries = 0, joinThread = false) {
        const genericEventPath = joinThread ?
            `/v1/threads/{threadId}/members` : `/v1/meetings/{shortId}/members`;
        const apiPath = joinThread ?
            `/v1/threads/${payload.threadId}/members` : `/v1/meetings/${payload.shortId}/members`;
        return this.performApiPost(apiPath, {
            displayName: payload.name,
        }, {
            customErrorHandler,
            eventProperties: {
                genericEventPath,
                customPropertiesProvider: () => ({ includesCaptcha: !!payload.captcha }),
            },
            retries,
        });
    }
    getConversation(payload, retries = 0) {
        const shortId = payload.shortId;
        return this.performApiGet(`/v1/meetings/${shortId}`, {
            customErrorHandler,
            eventProperties: {
                genericEventPath: '/v1/meetings/{shortId}',
            },
            retries,
        }).then(transformWrapper(shortId));
    }
}
exports.default = new MeetingsApiClient(config_1.default.urls.api.meetings);
